export default "__VITE_ASSET__P9gKSe9r__";